import { Table } from 'antd';
import { SpecialCoreTableProps } from '../../../../../@types/kr/types';
import { useAppContext } from '../../../../../providers/AppContext';

const KrTable = (props: SpecialCoreTableProps) => {
  const { configStates } = useAppContext();
  return (
    <>
      {configStates.showKrTable && (
        <div style={{ marginLeft: '0.5rem' }}>
          <Table
            columns={props.columns}
            dataSource={props.data}
            pagination={false}
            bordered={props.bordered}
            className="special-core-table"
          />
        </div>
      )}
    </>
  );
};

export default KrTable;
